<template>
  <div class="mobile_menu_vitrin2 slider">
    <div
      class="mobile_menu_vitrin_rows x remove-referid"
      v-if="referId.substring(0, 2)!='09'"
      @click="deletReferId(referId)"
    >
      <!-- v-if="$route.params.id.substring(0, 2)!='09'"  -->
      <div class="mobile_menu_vitrin_rows_svg">
        <svg
          width="14"
          height="16"
          viewBox="0 0 14 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 6C6 5.58578 5.66422 5.25 5.25 5.25C4.83578 5.25 4.5 5.58578 4.5 6L4.5 11C4.5 11.4142 4.83578 11.75 5.25 11.75C5.66422 11.75 6 11.4142 6 11L6 6Z"
            fill="#FF5064"
          />
          <path
            d="M9.5 6C9.5 5.58578 9.16422 5.25 8.75 5.25C8.33578 5.25 8 5.58578 8 6V11C8 11.4142 8.33578 11.75 8.75 11.75C9.16422 11.75 9.5 11.4142 9.5 11V6Z"
            fill="#FF5064"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.58578 1C4.22607 0.359711 5.09449 0 6 0L8 0C8.90551 0 9.77393 0.359711 10.4142 1L13 1C13.5523 1 14 1.44772 14 2C14 2.55228 13.5523 3 13 3L13 14C13 15.1046 12.1046 16 11 16L3 16C1.89543 16 1 15.1046 1 14L1 3C0.447715 3 0 2.55228 0 2C0 1.44772 0.447715 1 1 1L3.58578 1ZM9.58578 3L11 3L11 14L3 14L3 3L4.41422 3C5.0545 2.35971 5.92292 2 6.82843 2H7.17157C8.07708 2 8.9455 2.35971 9.58578 3Z"
            fill="#FF5064"
          />
        </svg>

      </div>
      <div class="mobile_menu_vitrin_rows_text remove-referId">
        حذف شناسه
        <span class="refer-choosen delete"></span>
      </div>
    </div>
    <div
      class="mobile_menu_vitrin_rows x"
      @click="copy(referId)"
    >
      <div class="mobile_menu_vitrin_rows_text copyLink">
        <span>کپی دعوت‌نامه</span>
        <span class="refer-choosen copy"></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  props: ["referId"],
  components: {},
  methods: {
    ...mapGetters(["modalShow", "modalContainerShow", "modalName"]),
    ...mapActions(["openModal", "closeModal", "reOpenModal"]),
    isLogin() {
      return this.$store.state.user.isLogin;
    },
    deletReferId(referId){
        this.$store.dispatch('deleteReferid',referId)
        this.openModal('deleteReferid')
        this.$emit("closeMenu", true)
    },
    copy(referid) {
      var self = this;
      this.message = `0️⃣3️⃣0️⃣7️⃣ سامانه «هفتاد سی» کاربران را در ۷۰ درصد سود بازار بزرگ محصولات اعتباری از جمله شارژ و بسته های اینترنت و قبض و… شریک می کند.
         ✅ شما روی خرید تمام کسانی که از طریق شما با سایت و اپ ۷۰۳۰ آشنا شده اند، سود مشخص خواهید داشت.
        ✅ از طریق لینک زیر در چند ثانیه عضو شوید و شروع به درآمدزائی کنید.
        🌐https://7030.ir/r/${referid}
        💌 شناسه‌ی معرف هنگام ثبت نام: ${referid}`;
      this.$copyText(this.message).then(function () {
        self.$store.dispatch("tost", {
          success: true,
          show: true,
          text: "لینک دعوت‌نامه شما کپی شد.",
          time: 5000,
        });
      });
      this.$emit("closeMenu", true)
    },
    
  },
};
</script>

<style>
.mobile_menu_vitrin_rows.x {
  
  width: 100%;
  padding: 16px;
  height: unset;
  line-height: unset;
  padding: 18px 35%;
  border-bottom: 1px solid #eee;
  cursor: pointer;
}
  .mobile_menu_vitrin_rows.x:last-child {
    border-bottom: none;
  }
.copyLink{
  color: #55C38C;
}
.remove-referId{
  color: #FF5064;
}
@media (max-width: 768px) {
  .mobile_menu_vitrin_rows.x {
    width: 100%;
    padding: 16px;
    height: unset;
    line-height: unset;
    margin: 0;
    /* border-bottom: 1px solid rgb(0, 0, 0); */
    cursor: pointer;
  }
  .mobile_menu_vitrin_rows.x:last-child {
    border-bottom: none;
  }
}
</style>
